import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'cr-chart-wrapper-xlarge',
  styleUrl: 'cr-chart-wrapper-xlarge.css',
  shadow: true,
})
export class CrChartWrapperXlarge {

  render() {
    return (
      <Host>
        <bx-tile><slot /></bx-tile>
      </Host>
    );
  }

}
